import { Button, Flex, Link } from '@chakra-ui/react'
import {
  OrbitControls,
  Environment,
  PerspectiveCamera,
} from '@react-three/drei'
import { Canvas } from '@react-three/fiber'
import { useEffect, useState } from 'react'
import { MeshMaker, ShapeCurve } from 'lib/mesh-maker'
import LampViewer from '../lamp-viewer'
import { Spline } from 'lib/spline-classes'
import { Sphere } from 'lib/sphere'
import { constants, getViewerRotation, modelTypes } from 'lib/constants'
import { Disk } from 'lib/disk'
import { Vector3 } from 'three'
import { GeometryState, WebsiteState, setStateFromFetched } from 'lib/state'
import { useRef } from 'react'

export default function Card(props) {
  const [isLoading, setIsLoading] = useState(false)
  const websiteState = new WebsiteState()
  const geometryState = new GeometryState(modelTypes.e27)
  const canvasRef = useRef(null)

  useEffect(() => {
    setStateFromFetched(websiteState, geometryState, props.geometryStatePost)
    websiteState.setHasMounted(true)
  }, [])

  return (
    <Flex
      direction={'column'}
      borderRadius={'1em'}
      borderColor={'black'}
      borderWidth={'2px'}
      padding={'1em'}
      margin={'1em'}
    >
      <Flex
        width={{ base: '200px', md: '10vw' }}
        height={{ base: '200px', md: '10vw' }}
        position={'relative'}
      >
        {isLoading && <Flex position={'absolute'}> Loading... </Flex>}
        <LampViewer
          canvasRef={canvasRef}
          socketColor={'0x000000'}
          geometryState={geometryState}
          websiteState={websiteState}
        />
      </Flex>
      <Flex direction={'row'} justifyContent={'space-between'}>
        {props.name}
        <Link href={window.location.origin + '?id=' + props.id}>
          <Button>Open</Button>
        </Link>
      </Flex>
    </Flex>
  )
}
